/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/anchor-has-content */
import React, { useRef, useState } from "react";
import { Popover } from "@material-ui/core";
import { toAbsoluteUrl } from "../../_metronic/utils/utils";

import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import CloseIcon from '@material-ui/icons/Close';
import { getJobServices,createPaymentLink,PAYMENT_SOCKET_URL} from "../crud/auth.crud";
import { parse } from "date-fns";
import WebSocket from 'isomorphic-ws';
import Alert from '@material-ui/lab/Alert'

import CircularProgress from '@material-ui/core/CircularProgress';


export default function Invoice({onClose,jobRequest,serviceTypes,onPayment, permission}) {
  
 const [jobServices,setJobServices] = useState([]);
 const [services,setServices] = useState(serviceTypes);
 const [loading,setLoading] = useState(false);
 const [total,setTotal] = useState(0);
 const [link,setLink] = useState(null);
 const [paymentLoading,setPaymentLoading] = useState(false);
 const [paymentStatus,setPaymentStatus] = useState(jobRequest.paidStatus);

 const [seconds, setSeconds] = useState(300); // 5 minutes * 60 seconds
  const [isActive, setIsActive] = useState(false);

  React.useEffect(() => {
    let intervalId;

 if (isActive) {
  intervalId = setInterval(() => {
    setSeconds((prevSeconds) => prevSeconds - 1);
  }, 1000);
}

return () => clearInterval(intervalId);
}, [isActive]);

React.useEffect(() => {
if (seconds === 0) {
  setIsActive(false);
  setPaymentLoading(false);
  setPaymentStatus(false);
}
}, [seconds]);

const toggleTimer = () => {
setIsActive(!isActive);
};

const resetTimer = () => {
setSeconds(300);
setIsActive(false);
};

const formatTime = (timeInSeconds) => {
const minutes = Math.floor(timeInSeconds / 60);
const remainingSeconds = timeInSeconds % 60;
return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
};

 React.useEffect(() => {
         const fetch = async () => {
             try {
              setLoading(true);

             




                 let services = [];
                 const response = await getJobServices(jobRequest.jobRequestKey);
                 services = response.data;
              
               console.log("final:::",services);
               //setIntervalz(parseInt(intervalz));
               setJobServices(services);
               let total= 0.0;
               services.map((sr)=>(
                  total = parseFloat(total) + parseFloat(sr.amount)
               ))
               setTotal(total);
               setLoading(false);
 
             } catch (e) {
                 console.log(e);
                 setLoading(false);
                 
             }
         };
         fetch();
     }, []);

     const paymentInvoke=()=>{
      createPaymentLink(jobRequest.id)
      .then(resp => {
        setPaymentLoading(true);
        //onPayment(resp.href);
        console.log(resp);
        console.log(resp.data.href);
        if(resp.data.checkoutSessionId!==null && resp.data.href!==null)
            {
              toggleTimer();
               //websocket
               const websocket = new WebSocket(PAYMENT_SOCKET_URL +jobRequest.id);

               websocket.addEventListener('open', function (event) {
                   //console.log("socket open")
                   console.log(event);
 
               });
 
               websocket.addEventListener('message', async function (event) {
                 console.log('Message from server ', event.data);
                 if (event.data.includes("APPROVED")) {
                   setPaymentLoading(false);
                   setPaymentStatus(true);
                   onPayment(jobRequest);
                 
                 }
               });
 
               websocket.addEventListener('error', function (event) {
                 console.log(event)
                 setPaymentLoading(false);
               });
 
               websocket.addEventListener('close', function (event) {
                 console.log("socket close")
                 setPaymentLoading(false);
               });
 
 
            
            setLink(resp.data.href);
            window.open(
              resp.data.href,
              '_blank',
              'width=600,height=400'
            );
          }
      })
      .catch(() => {
        setLoading(false);
      })
     }
 

  return (
    <>
      <div className="kt-portlet kt-portlet--height-fluid">
        <div className="kt-portlet__head">
          <div className="kt-portlet__head-label">
            <h3 className="kt-portlet__head-title">Invoice for {jobRequest.pEntity.firstName + ' '+jobRequest.pEntity.lastName } {'(#'+jobRequest.jobRequestKey+')'}</h3>
          </div>
          <div className="kt-portlet__head-toolbar">
           
            <a href="#" onClick={onClose}><CloseIcon style={{ color: '#5867dd',fontSize: 25}} /> </a>
          </div>
        </div>

        <div className="kt-portlet__body">
          {loading ===false &&
          <div className="kt-widget4">
          <div className="kt-widget4__item">
              <div className="kt-widget4__pic kt-widget4__pic--pic">
                {/*<img
                  alt=""
                  src={toAbsoluteUrl("/media/client-logos/logo1.png")}
                />*/}
              </div>
              <div className="kt-widget4__info">
                <a
                  className="kt-widget4__username"
                  href="#"
                />
                <a
                  className="kt-widget4__title"
                  href="#"
                >
                   Services
                </a>
                <p className="kt-widget4__text"></p>
              </div>
              <span className="kt-widget4__number kt-font-brand">Amount</span>
            </div>
            {/**loading &&
                          <div style={{alignItems: "center",display: 'flex', justifyContent: 'center',height: "100vh", width: "100vw"}}>
                            <CircularProgress />
                                   
              </div>
                                  */}
          {jobServices.map((st)=>(
            <div className="kt-widget4__item" key={st.id}>
              <div className="kt-widget4__pic kt-widget4__pic--pic">
                <img
                  alt=""
                  src={toAbsoluteUrl("/media/client-logos/logo1.png")}
                />
              </div>
              <div className="kt-widget4__info">
                <a
                  className="kt-widget4__username"
                  href="#"
                />
                <a
                  className="kt-widget4__title"
                  href="#"
                >
                   {services.find(x=>x.jobServiceTypeId===st.jobServiceTypeId).serviceType}
                </a>
                <p className="kt-widget4__text">{services.find(x=>x.jobServiceTypeId===st.jobServiceTypeId).serviceTypeDescription}</p>
              </div>
              <span className="kt-widget4__number kt-font-brand">${st.amount}</span>
            </div>
           ))}
            <div className="kt-widget4__item">
              <div className="kt-widget4__pic kt-widget4__pic--pic">
                
              </div>
              <div className="kt-widget4__info">
                <a
                  className="kt-widget4__username"
                  href="#"
                />
                <a
                  className="kt-widget4__title"
                  href="#"
                >
                   Total
                </a>
                <p className="kt-widget4__text"></p>
              </div>
              <span className="kt-widget4__number kt-font-brand">${total}</span>
            </div>
          </div>
          }
          {loading===true && 
              <div style={{alignItems: "center",display: 'flex', justifyContent: 'center'}}>
                  <CircularProgress />
              </div>
          }
        </div>
        <div className="kt-portlet__foot">
                    {!paymentLoading && paymentStatus===false && permission.includes("PAY:JOBINVOICE") &&
                    <Button
                        variant="outlined"
                        color="primary"
                        endIcon={<Icon>send</Icon>}
                        onClick={paymentInvoke}
                       
                        style={{'margin':'5px'}}
                        >
                        PAY ONLINE
                      </Button>
                      }
                      {paymentStatus===true &&
                        <Alert severity="info">Payment Received</Alert>
                      }  
                     
                      {paymentLoading &&
                          <div style={{alignItems: "center",display: 'flex', justifyContent: 'center'}}>                            
                            <Alert icon={<CircularProgress size={15} />}>&nbsp;&nbsp;Payment initiated.Please wait for {formatTime(seconds)}</Alert>      
                          </div>
                      }
                               
                
        </div>
        
        
        
      </div>
    </>
  );
}
